import { render } from "./StampBook.vue?vue&type=template&id=5654a7a2"
import script from "./StampBook.vue?vue&type=script&lang=js"
export * from "./StampBook.vue?vue&type=script&lang=js"
script.render = render

export default script